import React from 'react';


/*
let count  = {
  zero: 0,
  one: 0,
  two: 0,
  three: 0,
  four: 0,
  five: 0,
  six: 0,
  seven: 0,
  eight: 0,
  nine: 0,
}
*/
let timePrint = ''

function fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}

let interval;
let timerCount = 0;  

let interval_ms = 1000;

const AudioTimer = ({audioTimer_handler,clickArea,seconds_per_slide,required_slide_count}) => {
  const [timer, setTimer] = React.useState('0:00');
  
  React.useEffect(() => {
    console.log("AudioTimer useEffect",clickArea,seconds_per_slide,required_slide_count);
    if (clickArea) {

      if (clickArea === 'recording') {
        // update quickly once
        timePrint = fmtMSS(Math.floor(timerCount));
        let tmp_slide_number = Math.floor(timerCount / seconds_per_slide) + 1;
        if (tmp_slide_number > required_slide_count) {
          setTimer('Final Remarks - '+timePrint);
        } else {
          setTimer('Recording - Slide '+tmp_slide_number+' - '+timePrint);
        }
        audioTimer_handler(timerCount);
        
        interval = setInterval(() => {
          timerCount = timerCount + (interval_ms / 1000);
          timePrint = fmtMSS(Math.floor(timerCount));
          let tmp_slide_number = Math.floor(timerCount / seconds_per_slide) + 1;
          if (tmp_slide_number > required_slide_count) {
            setTimer('Final Remarks - '+timePrint);
          } else {
            setTimer('Recording - Slide '+tmp_slide_number+' - '+timePrint);
          }
          //console.log("AudioTimer Interval",timerCount);
          audioTimer_handler(timerCount);
        }, interval_ms); 
        /*
        interval = setInterval(() => {
          timerCount = timerCount + 1;
          if(timerCount <= 60) {
            timePrint = count.zero+1 <= 10 ? `00:0${count.zero++}` : `00:${count.zero++}`;
          } else if (timerCount <= 120) {
            timePrint = count.one+1 <= 10 ? `01:0${count.one++}` : `01:${count.one++}`;
          } else if (timerCount <= 180) {
            timePrint = count.two+1 <= 10 ? `02:0${count.two++}` : `02:${count.two++}`;
          } else if (timerCount <= 240) {
            timePrint = count.three+1 <= 10 ? `03:0${count.three++}` : `03:${count.three++}`;
          } else if (timerCount <= 300) {
            timePrint = count.four+1 <= 10 ? `04:0${count.four++}` : `04:${count.four++}` ;
          } else if (timerCount <= 360) {
            timePrint = count.five+1 <= 10 ? `05:0${count.five++}` : `05:${count.five++}`;
          } else if (timerCount <= 420) {
            timePrint = count.six+1 <= 10 ? `06:0${count.six++}` : `06:${count.six++}`;
          } else if (timerCount <= 480) {
            timePrint = count.seven+1 <= 10 ? `07:0${count.seven++}` : `07:${count.seven++}`;
          } else if (timerCount <= 540) {
            timePrint = count.eight+1 <= 10 ? `08:0${count.eight++}` : `08:${count.eight++}`;
          } else if (timerCount <= 600) {
            timePrint = count.nine+1 <= 10 ? `09:0${count.nine++}` : `09:${count.nine++}`;
          } else {
            clearInterval(interval)
          }
          setTimer(timePrint);
        }, 1000);
        */
      
      // 'startRecording' not being used here
      /*
      } else if (clickArea === 'startRecording' && interval) {
        clearInterval(interval)
        timerCount = 0;
        setTimer(null);
        count  = {
          zero: 0,
          one: 0,
          two: 0,
          three: 0,
          four: 0,
          five: 0,
          six: 0,
          seven: 0,
          eight: 0,
          nine: 0,
        };
        */
      } else if (clickArea === 'paused') {
        clearInterval(interval);
        let tmp_slide_number = Math.floor(timerCount / seconds_per_slide) + 1;
        setTimer('Paused - Slide '+tmp_slide_number+' - '+timePrint);
      } else if (clickArea === 'inactive') {
        clearInterval(interval);
        setTimer('Finished '+timePrint);
        timerCount = 0;
        /*
        count  = {
          zero: 0,
          one: 0,
          two: 0,
          three: 0,
          four: 0,
          five: 0,
          six: 0,
          seven: 0,
          eight: 0,
          nine: 0,
        };
        */
      }
    }
  }, [clickArea]);

  React.useEffect(() => {
    return () => {
      // make sure timer is reset to zero. this can happen if we go "previous" then come back.
      console.log("Perform AudioTimer Cleanup");
      clearInterval(interval);
      timerCount = 0;
    }
  }, []);

  return (
    <h2 style={{textAlign: 'center', color: 'red'}}>{timer}</h2>
  )
}

export default AudioTimer
